export default {
    Journals: 'journal-box',
    JournalFiles: 'journal-files-box',
    Documents: 'documents-box',
    MedcomDocuments: 'client-medcom-documents',
    Surveys: 'surveys-box',
    Messages: 'messages-box',
    Notifications: 'timeline-box',
    ClientInformation: 'information-box',
    Appointments: 'bookings-box',
    Invoices: 'invoices-box',
    Vouchers: 'voucher-box',
    Payments: 'payments-box',
    OnlineCourses: 'online-courses-box',
    ContactsAndPayers: 'other-payers-box',
    TreatmentCourses: 'treatment-courses-box',
    Subscriptions: 'memberships-box',
    Diagnosis: 'diagnoses-box',
    MessagingService: 'helsenett',
    Treatments: 'treatments-box',
    GeneralPractitioner: 'gp-box',
}